import { CGCardMedium } from 'types/cardgift';
import { CARD_MEDIUM_DIGITAL, CARD_MEDIUM_PHYSICAL } from 'utilities/constants';
import LanguageIcon from '@mui/icons-material/Language';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Box from '@mui/material/Box';
import { ReactComponent as DigitalAndPhysicalIcon } from '../../assets/icons/digitalAndPhysical.svg';
import SvgIcon from '@mui/material/SvgIcon';

interface ProductMediumsDisplayProps {
  mediums: CGCardMedium[];
  sx?: SxProps<Theme>;
}
const ProductMediumsDisplay: React.FC<ProductMediumsDisplayProps> = ({ mediums, sx }) => {
  if (mediums.length === 2)
    return (
      <Box display="flex" alignItems="center" sx={sx}>
        <SvgIcon component={DigitalAndPhysicalIcon} sx={{ mr: 0.75, width: '1.5em' }} viewBox="0 0 37 24" />
        Digital / Physical
      </Box>
    );
  if (mediums.indexOf(CARD_MEDIUM_DIGITAL) > -1)
    return (
      <Box display="flex" alignItems="center" sx={sx}>
        <LanguageIcon sx={{ mr: 0.75 }} />
        Digital
      </Box>
    );
  if (mediums.indexOf(CARD_MEDIUM_PHYSICAL) > -1)
    return (
      <Box display="flex" alignItems="center" sx={sx}>
        <CreditCardIcon sx={{ mr: 0.75 }} />
        Physical
      </Box>
    );
  return null;
};

export default ProductMediumsDisplay;
